import { useEffect, useState } from "react";
import { tss } from "tss-react";
import { Input } from "@mui/material";
import Dash from "assets/images/Input--.png";
import Multi from "assets/images/Input-multi.png";
import MultiValues from "assets/images/Input-multivalues.png";

var useStyles = tss.create({
    border: {
        borderBottomColor: "#E5E9F1",
    },
});

/*
const overrideMUIStyles = tss.create(
	{
		underline: {
			borderBottom: '1px solid #EBEBEB',
		},
	},
	{ name: 'MuiInput' }
);
*/

var limboSettting: any = {};

type IDashInput = {
    name: string;
    value: number;
    onChange: (evt: any) => void;
    isLimbo?: boolean;
    inputProps?: any;
    style?: any;
    className?: any;
    disabled?: boolean;
    type?: string;
    fullWidth?: boolean;
};

export default function DashInput(props: IDashInput) {
    var { classes, cx } = useStyles();
    var { name, isLimbo, inputProps, style, className, disabled, type, fullWidth } = props;
    var [update, setUpdate] = useState(false);

    if (!limboSettting[name]) {
        limboSettting[name] = { limbo: isLimbo, value: props.value || 0 };
    }

    var { value, limbo } = limboSettting[name];
    /*
	console.log(
		'name:',
		name,
		'|isLimbo:',
		isLimbo,
		'|limbo:',
		limbo,
		'|value:',
		value
	);
	*/
    const setValue = (value: number) => {
        limboSettting[name].value = value;
    };

    const setShowDash = (value: boolean) => {
        limboSettting[name].limbo = value;
        setUpdate(!update);
    };

    const onChange = (evt: any) => {
        props.onChange(evt);
        setValue(evt.target.value);
        setShowDash(false);
    };

    useEffect(() => {
        limboSettting[name] = {
            limbo: isLimbo,
            value: props.value || 0,
        };
        setUpdate((prevVal) => !prevVal);
    }, [name, isLimbo, props.value]);

    var imgType = Dash;
    if (type === "multi") {
        imgType = Multi;
    } else if (type === "multivalues") {
        imgType = MultiValues;
    }
    return (
        <div style={{ height: "50%" }}>
            {limbo ? (
                <div style={{ position: "relative" }}>
                    <div
                        onClick={(e) => setShowDash(false)}
                        style={{
                            ...style,
                            position: "absolute",
                            zIndex: 3,
                            backgroundColor: "white",
                            display: limbo ? "block" : "none",
                        }}
                    >
                        <img
                            alt="Multi"
                            src={imgType}
                            style={{
                                width: "100%",
                                height: "100%",
                                zIndex: 3,
                            }}
                        />
                    </div>
                </div>
            ) : (
                ""
            )}
            <Input
                type="number"
                value={value}
                fullWidth={fullWidth}
                className={cx(className, limboSettting[name] ? classes.border : "")}
                inputProps={{ ...inputProps }}
                onChange={onChange}
                disabled={disabled ? disabled : false}
            />
        </div>
    );
}
